import generateRender from 'shared/utils/generateRender';
import DefaultForm from './DefaultForm';

const ForgetPasswordForm = generateRender({
  default: DefaultForm,
});

export default ForgetPasswordForm;

